<div class="collection-view">
@if(user) {
    <div class="row">
        <div class="col-12 col-md-3 col-xxl-2">
            <aside>
                <div class="side-panel">
                    <h4>{{ 'collection.description'|translate }}</h4>
                    {{ collection?.description }}
                    @if (collection?.permissions?.canEdit) {
                        <button class="wide-button" mat-raised-button (click)="editCollection()">
                            <span>{{ 'collection.action.edit'|translate }}</span>
                        </button>
                    }
                </div>
                <div class="side-panel">
                    <dl>
                        @if (collection?.createdAt) {
                            <dt>{{ 'collection.createddate'|translate }}:</dt>
                            <dd>{{ collection?.createdAt | dateLocale }}</dd>
                        }
                        <dt>{{ 'collection.modifieddate'|translate }}:</dt>
                        <dd>{{ collection?.updatedAt | dateLocale }}</dd>
                        @if (collection?.createdBy) {
                            <dt>{{'collection.owner'| translate}}:</dt>
                            <dd class="has-button">{{ collection?.createdBy?.fullName }}
                                @if (collection?.permissions?.canTransferOwnership) {
                                    <button mat-icon-button matIconSuffix (click)="transferOwnership()">
                                        <mat-icon fontIcon="edit"></mat-icon>
                                    </button>
                                }
                            </dd>
                        }
                    </dl>
                    @if (collection?.permissions?.canManageAccess) {
                        <button class="wide-button"  mat-raised-button (click)="showAccess()">
                            <span>{{ 'collection.action.showaccess'|translate }}</span>
                        </button>
                    }
                </div>
                <div class="side-panel">
                    <h4>{{ 'collection.sharestatus'| translate }}</h4>
                    <dl>
                        @if (collection?.sharedLink) {
                            <dt>{{ 'collection.sharedlink'|translate }}:</dt>
                            <dd>
                                <mat-form-field>
                                    <input matInput [value]="collection?.sharedLink?.url" readonly>
                                    <button mat-icon-button matSuffix (click)="copyLink(collection?.sharedLink?.url!)">
                                        <mat-icon fontIcon="content_copy"></mat-icon>
                                    </button>
                                </mat-form-field>
                            </dd>
                        }
                        @if (collection?.publication) {
                            <dt>{{ 'collection.publication'|translate }}:</dt>
                            <dd>
                                <mat-form-field>
                                    <input matInput [value]="collection?.publication?.url" readonly>
                                    <button mat-icon-button matSuffix (click)="copyLink(collection?.publication?.url!)">
                                        <mat-icon fontIcon="content_copy"></mat-icon>
                                    </button>
                                </mat-form-field>

                            </dd>
                        }

                    </dl>
                    @if (collection?.permissions?.canPublish || collection?.permissions?.canShareLink) {
                        <button class="wide-button"  mat-raised-button (click)="shareCollection()">
                            <span>{{ 'collection.action.share'|translate }}</span>
                        </button>
                    }
                </div>
            </aside>
        </div>
        <div class="col-12 col-md-9 col-xxl-10">
            <div class="row">
                <div class="col-12">
                    <header>
                        <h1>{{ collection?.name }}</h1>
                        @if (collection?.permissions?.canEdit || collection?.permissions?.canShareLink || collection?.permissions?.canDelete) {
                            <div id="collection-actions">
                                <button mat-button [matMenuTriggerFor]="collectionMenu">
                                    <mat-icon fontIcon="menu"></mat-icon>
                                </button>
                                <mat-menu #collectionMenu>
                                    @if (collection?.permissions?.canEdit) {
                                        <button mat-menu-item (click)="editCollection()">
                                            <span>{{ 'collection.action.edit'|translate }}</span>
                                        </button>
                                    }
                                    @if (collection?.permissions?.canShareLink) {
                                        <button mat-menu-item (click)="shareCollection()">
                                            <span>{{ 'collection.action.share'|translate }}</span>
                                        </button>
                                    }
                                    @if (collection?.permissions?.canDelete) {
                                        <button mat-menu-item (click)="deleteCollection()">
                                            <span>{{ 'collection.action.delete'|translate }}</span>
                                        </button>
                                    }
                                </mat-menu>
                            </div>
                        }
                    </header>
                </div>

            </div>
            <div class="row">
                <div class="col-12">
                    <section id="collection-content">
                        <app-asset-result [assets]="assets"
                                          [totalItems]="totalAssets"
                                          [renderStyle]="AssetRenderStyle.tile">
                        </app-asset-result>
                    </section>
                </div>
            </div>
        </div>
    </div>
}

</div>
